import React, { forwardRef } from 'react'
import ObrysIkony from './ObrysIkony'

/**
 * Dobór ładowarki do auta: wtyczka. Krąg jest ten sam co w symbolu zasilania (PowerIcon przy
 * „Ładowarkach” w katalogu), ale w szczelinie stoją dwa bolce zamiast jednej kreski, a od dołu
 * wychodzi przewód. Ikony są więc z jednej rodziny, a jednak nie do pomylenia.
 *
 * Zastępuje CpuChipIcon (2026-10-08): procesor nie mówił nic o ładowaniu auta.
 */
const IkonaDoboruLadowarki = forwardRef((props, ref) => (
  <ObrysIkony ref={ref} {...props}>
    <path d='M15.375 5.154a6.75 6.75 0 1 1-6.75 0' />
    <path d='M10 3v5.25M14 3v5.25' />
    <path d='M12 17.75v1.5a1.5 1.5 0 0 0 1.5 1.5h3' />
  </ObrysIkony>
))

export default IkonaDoboruLadowarki
